import { render } from "./ModalAplicarAvaliacao.vue?vue&type=template&id=3f7044e3&scoped=true"
import script from "./ModalAplicarAvaliacao.vue?vue&type=script&lang=js"
export * from "./ModalAplicarAvaliacao.vue?vue&type=script&lang=js"

import "./ModalAplicarAvaliacao.vue?vue&type=style&index=0&id=3f7044e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7044e3"]])

export default __exports__